/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "pages.preview",
  title: "Pages Preview",
  description: "Previews a page, blog, or other content.",
  styling: {
    styles: [
      {
        selector: ".pages-preview-media",
        styles: [
          "object-fit: cover;",
          "width: 100%;",
          "height: 100%;"
        ]
      },
      {
        selector: ".pages-preview-label",
        styles: [
          "padding-left: 1.5rem;",
          "padding-bottom: 0;",
          "margin: 0;"
        ]
      },
      {
        selector: ".pages-preview-rule",
        styles: [
          "border-bottom: var(--bs-blue) 1px solid;",
          "width: 35%;",
          "margin-left: 1.5rem;"
        ]
      },
      {
        selector: ".pages-preview-text-shell",
        styles: [
          "padding-top: 0 !important;"
        ]
      },
      {
        selector: ".pages-preview-title",
        styles: [
          "font-size: 2.2em;",
          "font-weight: 800;",
          "line-height: 1.5em;",
          "padding-top: 1rem;"
        ]
      },
      {
        selector: ".pages-preview-title-mobile",
        styles: [
          "font-size: 2.2em;",
          "font-weight: 800;",
          "line-height: 1.5em;"
        ]
      },
      {
        selector: ".pages-preview-separator-shell",
        styles: [
          "padding-top: 0;",
          "padding-bottom: 1rem;"
        ]
      },
      {
        selector: ".pages-preview-separator-shell-mobile",
        styles: [
          "padding-top: 0;",
          "padding-bottom: 4rem;"
        ]
      },
      {
        selector: ".pages-preview-separator",
        styles: [
          "border-top: .5rem var(--bs-blue) solid;"
        ]
      },
      {
        selector: ".pages-preview-quote-rule",
        styles: [
          "margin: 3rem;",
          "border-bottom: 2px solid var(--bs-blue);"
        ]
      },
      {
        selector: ".pages-preview-mobile-hero",
        styles: [
          "position: relative;",
          "padding-bottom: 10rem !important;"
        ]
      },
      {
        selector: ".pages-preview-mobile-hero-img",
        styles: [
          "position: absolute;",
          "inset: 0;",
          "width: 100%;",
          "height: 100%;",
          "object-fit: cover;"
        ]
      },
      {
        selector: ".pages-preview-mobile-hero-content",
        styles: [
          "position: relative;"
        ]
      }
    ]
  },
  fields: {
    "previewTitle": {
      title: "Preview Title",
      type: "string",
      description: "The title of the preview.",
      defaults: "Preview"
    }, "title": {
      title: "Original Title",
      type: "string",
      description: "The title of the page."
    }, "description": {
      title: "Description",
        type: "string",
        description: "The description of the blog."
    }, "image": {
        title: "Image",
        type: "uri",
        description: "The image of the blog."
    }, "inner": {
        title: "Inner",
        type: "inner",
        description: "The inner content of the blog."
    }, "url": {
        title: "Url",
        type: "uri",
        description: "The url of the blog."
    }, "pageType": {
        title: "Page Type",
        type: "string",
        description: "The page type used for preview style selection."
    }, "on": {
        title: "Dates",
        type: "object",
        fields: {
            "published": {
                title: "Published",
                type: "date",
                description: "The date the page was published."
            }, "modified": {
                title: "Modified",
                type: "date",
                description: "The date the page was last modified."
            }, "created": {
                title: "Created",
                type: "date",
                description: "The date the page was created."
            }
            // , "expires": {
            //     title: "Expires",
            //     type: "date",
            //     description: "The date the page expires."
            // }
        },
        description: "The dates of the page."
    }
  }, 
  passthrough: true
});

// var namespace = module.exports.namespace;
// var namespace = "pages.preview";
// exports.namespace = namespace;

var f = require("../scripts/f.js");
var jsonRender = require("../interface/jsonRender.js");

// var fs = require("fs");
// var resolve = require("../../../uam/functions/resolve.js").function;
// var resolve = require("../../../")

// var uai = require("../interface/interface.js");
// const { l } = require("../../../uam/sanitize.js");

var describeAccountingDate = require("../../../uam/functions/describeAccountingDate.js").function;

/**
 * We'll add the footnote to the footnotes for the page, and output the corresponding number
 * @param {*} ele The json element to render the footnote on.
 * @returns The final renderalbe object, dom or ua/json.
 */
exports.render = async function (options) {

    // var entry = false;
    // var extraPath = "";

    // if ("src" in options) {
    //     var json = false;
    //     if ("UATisServer" in window && window.UATisServer) {



    //       console.info("Server side blog preview not implemented yet.", options);

    //       var onlyClientSideRender = {
    //         "n": "json",
    //         "type": "ua/interface",
    //         // "render": "no-server",
    //         "i": JSON.stringify(options, null, 0) + ""
    //       };

    //       // console.info("Only client side render", onlyClientSideRender);
    //       return await jsonRender.render(onlyClientSideRender);
            
    //         // throw new Error("Server side blog preview not implemented yet.");
            
    //     } else {

    //         var blogUri = [location.protocol, '//', location.host, location.pathname]
    //         blogUri = blogUri.join('');
    //         blogUri = blogUri + options.src;
    //         //blogUri = blogUri.replace("/../", "/");

    //         var response = false;
    //         try {
    //             // fetch synchronously

    //             var xmlHttp = new XMLHttpRequest();
    //             xmlHttp.open("GET", blogUri, false); // false for synchronous request
    //             xmlHttp.send(null);
    //             response = xmlHttp.responseText;
    //             entry = JSON.parse(response);

    //             // json = fetch(window.location.href + options.src, {
    //             //     method: 'GET',
    //             //     headers: {
    //             //         'Content-Type': 'application/json',
    //             //         'Accept': 'application/json'//,
    //             //         //'UA-Version': config.version
    //             //     }
    //             // });
    //             // entry = json.json();

    //             //get the folder path
    //             var path = options.src.split("/");
    //             path.pop();
    //             extraPath = path.join("/") + "/";

    //         } catch (error) {
    //             console.error(`Error fetching blog entry at ${blogUri}.`, {
    //                 blogUri: blogUri,
    //                 error: error,
    //                 response: response
    //             });
    //             throw error;
    //         }

    //     }
    // } else {
    //     entry = options;
    // }

    // console.log("Entry", entry);

    var entry = options;

    var previewTitle = "Preview";

    if ("previewTitle" in options) {
      previewTitle = options.previewTitle;
    }

    try {
     
      entry.on.publishedDescribed = describeAccountingDate(entry.on.published);

    } catch (error) {
      
      console.error("Entry Failed", {
        entry: entry,
        on: entry.on,
        error: f.GenerateSafeError(error)
      });
    
      throw error;
      
    }

    if (!("title" in options)) {
        options.title = GetPublishedOnDescription(entry.on.publishedDescribed);
    }


    var typedPreview = await RenderTypedPreview(entry, options);
    if (typedPreview) {
      return typedPreview;
    }

    var blog = [{
        "n": "div",
        "class": "col-12 d-none d-md-flex",
        "inner": [
          {
            "n": "div",
            "class": "col-4 d-flex ",
            "inner": {
              "n": "img",
              "class": "pages-preview-media",
              "src": entry.image,
              "alt": ""
            }
          },
          {
            "n": "div",
            "class": "rounded d-flex align-items-center rounded", 
            "inner": [
              {
                "n": "div",
                "class": "",
                "inner": [
                  {
                    "n": "p",
                    "class": "fs-6 text-primary pages-preview-label",
                    "inner": [
                      previewTitle
                    ]
                  },
                  {
                    "n": "div",
                    "class": "pages-preview-rule"
                  },
                  {
                    "n": "div",
                    "class": "p-4 pages-preview-text-shell",
                    "inner": [
                      {
                        "n": "h1",
                        "class": "text-start text-uppercase text-white break-letter pages-preview-title",
                        "inner": [
                          entry.title
                        ]
                      },
                      {
                        "n": "div",
                        "class": "pages-preview-separator-shell",
                        "inner": [
                          {
                            "n": "div",
                            "class": "w-50 pages-preview-separator",
                          }
                        ]
                      }, 
                      {
                        "n": "blockquote",
                        "class": "blockquote text-left",
                        "i": [{
                            n: "p",
                            c: "p-2",
                            inner: options.description
                        }, {
                          "n": "div",
                          "c": "pages-preview-quote-rule"
                        }]
                      }
                      // ,
                      // entry.inner
                    ]
                  },
                  {
                    "n": "div",
                    "class": "row p-3 justify-content-end",
                    "inner": [
                      {
                        "n": "a",
                        "class": "btn col-6 btn-primary btn-large btn-hover-white ",
                        "href": entry.url,
                        "inner": [
                          "Read More"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }, {
        "n": "div",
        "class": "col-12 d-flex d-md-none",
        "inner": [
          {
            "n": "div",
            "class": "rounded d-block align-items-center rounded col-12",
            "inner": [
              // {
              //   "n": "img",
              //   "class": "image-shadow image-fill box-shadow",
              //   "src": entry.image
              // }, 
              {
                "n": "div",
                "onclick": `window.location.href = '${entry.url}';`,
                "class": "d-block align-items-center p-3 col-12 pages-preview-mobile-hero",
                "i": [
                  {
                    "n": "img",
                    "class": "pages-preview-mobile-hero-img",
                    "src": entry.image,
                    "alt": ""
                  },
                  {
                    "n": "div",
                    "class": "pages-preview-mobile-hero-content",
                    "i": [
                  {
                    "n": "h1",
                    "class": "text-start text-uppercase text-white break-letter pages-preview-title-mobile",
                    "inner": [{
                      "n": "span",
                      "class": "",
                      "i": entry.title
                    }]
                  },
                  {
                    "n": "div",
                    "class": "pages-preview-separator-shell-mobile",
                    "inner": [
                      {
                        "n": "div",
                        "class": "w-50 pages-preview-separator",
                      }
                    ]
                  }]
                  },
                ]
              }, {
                "n": "div",
                "class": "d-block",
                "inner": [
                  {
                    "n": "p",
                    "class": "fs-6 text-primary pages-preview-label",
                    "inner": {
                      "n": "a",
                      "href": entry.url,
                      "i": previewTitle
                    }
                  },
                  // {
                  //   "n": "div",
                  //   "style": "border-bottom: var(--bs-blue) 1px solid; width: 35%; margin-left:1.5rem;"
                  // },
                  {
                    "n": "div",
                    "class": "p-4 pages-preview-text-shell",
                    "inner": [
                      {
                        "n": "blockquote",
                        "class": "blockquote text-left",
                        "i": [{
                          n: "p",
                          c: "p-2",
                          inner: options.description
                        }, {
                          "n": "div",
                          "c": "pages-preview-quote-rule"
                        }]
                    }
                    //, entry.inner
                   ]
                  }
                ]
              }, {
                "n": "div",
                "class": "row p-3 justify-content-end",
                "inner": [
                  {
                    "n": "a",
                    "class": "btn col-6 btn-primary btn-large bg-white-hover text-primary-hover",
                    "href": entry.url,
                    "inner": [
                      "Read More"
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ];

    return blog;

};

async function RenderTypedPreview(entry, options) {
  var pageType = (options.pageType || entry.pageType || "pages.web") + "";
  var previewElement = null;

  if (options.previewNamespace) {
    previewElement = jsonRender.search(options.previewNamespace);
  }

  if (!(previewElement)) {
    previewElement = jsonRender.searchByDefinition("define.pagePreview.pageType", pageType);
  }

  if (!(previewElement)) {
    previewElement = jsonRender.searchByDefinition("define.pagePreview.id", pageType);
  }

  if (!(previewElement) || typeof previewElement.render !== "function") return null;

  return await previewElement.render(options);
}

function GetPublishedOnDescription(published) {

  //convert YYYYMMDD or YYYYMMDDHHMM to date time

  var defMessage = "Published on " + published;

  var date = new Date(published);

  if (date == false) {
    return defMessage;
  }

  //get the difference between now and the date
  var diff = new Date() - date;

  //if the difference is less than 1 day, return "today"
  if (diff < 86400000) {
    return "Published today";
  }

  //if the difference is less than 2 days, return "yesterday"
  if (diff < 172800000) {
    return "Published yesterday";
  }

  //if the difference is less than 7 days, return "x days ago"
  if (diff < 604800000) {
    return "Published " + Math.floor(diff / 86400000) + " days ago";
  }

  //if the difference is less than 2 weeks, return "last week"
  if (diff < 1209600000) {
    return "Published last week";
  }

  //if the difference is less than 1 month, return "x weeks ago"
  if (diff < 2592000000) {
    return "Published " + Math.floor(diff / 604800000) + " weeks ago";
  }

  //if the difference is less than 2 months, return "last month"
  if (diff < 5184000000) {
    return "Published last month";
  }

  //if the difference is less than 1 year, return "x months ago"
  if (diff < 31536000000) {
    return "Published " + Math.floor(diff / 2592000000) + " months ago";
  }

  return defMessage;
}

function getEntryBySource(src) {
    //fetch the file contents client side

}
